export default __webpack_public_path__ + "static/media/2015.96cf51ae.webp";